module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAWUlEQVQ4jWNsaGhgwAXW8+XCmP+hNGPgp8k41TMwMDAw4ZUlA4waOAgNZNTve0uMOniyIaSQ6i5kQbKdGEBQLU1cSDBcGEgIQxZ8eRMpL8PBaF4eNZAGBgIArdoQLAQtTyoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/images/block_add.png
// module id = NuT6
// module chunks = 2